import { translate } from '../i18n';

/** TON Explorer base URL — switches between testnet and mainnet via env var */
export const EXPLORER_BASE = import.meta.env.VITE_TON_NETWORK === 'mainnet'
    ? 'https://tonviewer.com'
    : 'https://testnet.tonviewer.com';

/**
 * Authenticated fetch wrapper.
 * Automatically attaches Telegram initData to all API requests.
 * This is how we prove to the backend that the request came from Telegram.
 */

function getInitData(): string {
    try {
        return window.Telegram?.WebApp?.initData || '';
    } catch {
        return '';
    }
}

/**
 * Fetch with Telegram auth header.
 * Drop-in replacement for `fetch()` — same API, adds auth automatically.
 * Handles 401 (session expired) globally so every API call gets the same UX.
 */
export async function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
    const initData = getInitData();

    const headers = new Headers(init?.headers);
    if (initData) {
        headers.set('X-Telegram-Init-Data', initData);
    }

    const resp = await fetch(input, {
        ...init,
        headers,
    });

    // Global 401 handler — session expired. Show clear message, not a confusing generic error.
    if (resp.status === 401) {
        try {
            const wa = (window as any).Telegram?.WebApp;
            if (wa?.showPopup) {
                wa.showPopup({
                    title: translate('error.session_timeout_title'),
                    message: translate('error.session_timeout_message'),
                    buttons: [{ type: 'ok' }],
                }, () => { wa.close(); });
            } else {
                alert(translate('error.session_timeout_message'));
            }
        } catch {}
    }

    return resp;
}
